<HomeNavBar />

<div class="container-fluid">
     <button
      class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
      @click="$router.back()">
      <i class="bi bi-arrow-left fs-4"></i>
    </button>

  <div class="mt-4 d-none" v-if="client_features.show_library">
    <!-- Section Title -->
    <div class="text-start mb-4">
      <h2 class="section-title-census">
        Socio-Economic Empowerment Index for Women 2024 Products
      </h2>
      <div class="underline"></div>
    </div>

    <!-- Product Grid -->
    <div class="row text-center mt-5">
      <div class="col-md-4 col-sm-6 mb-4">
        <div class="">
          <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/research.webp" class="course-card" alt="SG Presentation" />
          <a href="/documents/research.pdf" class="mt-2 report-link course-title">Research Report</a>
        </div>
      </div>

      <div class="col-md-4 col-sm-6 mb-4">
        <div class="">
          <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/infographics.webp" class="course-card" alt="Census 2022 Statistical Release" />
          <a href="/documents/Infographics.pdf" class="mt-3 report-link course-title">Infographics</a>
        </div>
      </div>

      <div class="col-md-4 col-sm-6 mb-4">
        <div class="">
          <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/methodology.webp" class="course-card" alt="Province at a Glance" />
          <a href="/documents/methodology.pdf" class="mt-2 report-link course-title">Methodology Report</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Saved Documents Header -->
  <div class="mb-4 mt-3">
    <div class="row">
      <div class="col-12 text-center">
        <h4 class="fw-bold text-primary mb-1">
          Saved Documents
        </h4>
      </div>
    </div>
  </div>

  <div v-if="loading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-else-if="!library_resources.length" class="text-center py-5 my-4">
  <i class="bi bi-folder2-open fs-1 text-muted mb-2"></i>
  <h5 class="text-dark mb-2">No saved documents found</h5>
  <p class="text-muted mb-0">Upload or save document resources to see them here.</p>
</div>

  <!-- Documents Grid -->
  <div class="row g-4" v-else>
    <!-- Document 1 -->
    <div class="col-6 col-sm-4 col-md-3 col-lg-2" v-for="document in library_resources" :key="document.id">
      <div class="file-card p-3 h-100 d-flex flex-column">
        <!-- Spinner overlay -->
        <div v-if="deletingId === document.id"
          class="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center">
          <div class="spinner-border text-danger" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <small class="mt-2 text-danger">Deleting...</small>
        </div>

        <div class="d-flex align-items-center mb-3 w-100">
          <!-- File Icon -->
          <div class="file-icon-box me-3 d-flex align-items-center justify-content-center text-white flex-shrink-0"
            :class="get_file_class(document.report_file.file.name)">
            {{ get_file_label(document.report_file.file.name) }}
          </div>
          <!-- File Info + Actions -->
          <div class="file-name-wrap flex-grow-1">
            <!-- File Name -->
            <h6 class="file-name mb-0 w-100" :title="document.report_file.file.name">
              {{ document.report_file.file.name }}
            </h6>
          </div>
        </div>

        <!-- File Actions -->
        <div class="d-flex justify-content-between gap-2 align-items-center mt-auto">
          <a href="#" class="btn btn-sm" @click="open_preview(document.report_file)">
            <i class="bi bi-eye"></i>
          </a>
          <!-- Bookmark/Delete -->
          <a href="#" class="btn btn-sm p-0" @click.prevent="delete_document(document.id)">
            <i v-if="document.is_saved" class="bi bi-bookmark-x-fill text-danger fs-5"></i>
            <i v-else class="bi bi-bookmark-check-fill text-dark"></i>
          </a>
          <!-- Download -->
          <a href="#" class="btn btn-sm p-0" @click.prevent="downloadFile(document.report_file.file)">
            <i class="bi bi-download"></i>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="upload_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="upload_modal_label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="upload_modal_label">Upload Document</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form id="upload_form" @submit.prevent="submitLibraryResource">
            <span class="badge bg-primary text-xxs" data-bs-toggle="modal" data-bs-target="#category_modal"
              data-bs-dismiss="modal">
              Tag a category :
            </span>
            <span v-for="cat in selected_categories" :key="cat.id" class="text-xxs ms-1 fw-bold">
              {{ cat.name }},
            </span>

            <div class="mb-3">
              <label for="document_title" class="form-label">Document Title</label>
              <input type="text" class="form-control form-control-sm text-xxs rounded-3" id="document_title"
                v-model="title" required />
            </div>

            <div class="mb-3">
              <label for="document_description" class="form-label">Description</label>
              <textarea class="form-control form-control-sm text-xxs rounded-3" id="document_description"
                v-model="description" rows="3" required></textarea>
            </div>

            <div class="mb-3">
              <label for="document_file" class="form-label">Upload File</label>
              <input type="file" class="form-control form-control-sm text-xxs rounded-3" id="document_file"
                @change="handleFileUpload" required />
            </div>

            <button type="submit" class="btn btn-primary btn-sm float-end" :disabled="loading_upload">
              <span v-if="loading_upload" class="spinner-border spinner-border-sm me-2" role="status"></span>
              <span>{{ loading_upload ? 'Saving...' : 'Save' }}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="category_modal" tabindex="-1" aria-labelledby="category_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-sm">
        <div class="modal-header">
          <h6 class="modal-title" id="category_modal_label">
            Select a Category
          </h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-for="category in grouped_tags" :key="category.id" class="col-md-6">
            <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>
            <multiselect :model-value="selected_tags.get(category.id)"
              @update:modelValue="updateTagSelection(category.id, $event)" :options="category.tags" :multiple="true"
              :preserve-search="true" :close-on-select="false" :clear-on-select="false" placeholder="Select tags"
              class="text-xs fw-500 mb-3" track-by="id" label="name">
              <template #option="{ option }">
                <span v-if="option" class="fw-500 text-xxs">
                  {{ option.name }}
                </span>
              </template>
              <template #selection="{ values }">
                <span v-for="(tag, index) in values" :key="index" class="badge bg-primary me-1">
                  {{ tag.name }}
                </span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="text-end">
          <button type="button" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3" @click="submit_tags"
            data-bs-toggle="modal" data-bs-target="#upload_modal" data-bs-dismiss="modal">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div class="modal fade" id="preview_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title">Preview</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body text-center position-relative">
            <!-- Loader Spinner -->
            <div v-if="loading_preview" class="d-flex justify-content-center align-items-center" width="100%"
              height="100%">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <!-- PDF Preview -->
            <div v-if="preview_type === 'pdf'" class="ratio ratio-16x9">
              <iframe :src="preview_url" width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
            </div>

            <!-- Image Preview -->
            <div v-else-if="preview_type === 'image'">
              <img :src="preview_url" class="img-fluid rounded" @load="on_content_loaded" />
            </div>

            <!-- Video Preview -->
            <div v-else-if="preview_type === 'video'">
              <video controls class="img-fluid rounded" @loadedmetadata="on_content_loaded">
                <source :src="preview_url" :type="'video/' + preview_url.split('.').pop()" />
                Your browser does not support the video tag.
              </video>
            </div>

            <!-- Audio Preview -->
            <div v-else-if="preview_type === 'audio'">
              <audio controls class="w-100 my-3" @loadedmetadata="on_content_loaded">
                <source :src="preview_url" :type="'audio/' + preview_url.split('.').pop()" />
                Your browser does not support the audio element.
              </audio>
            </div>

            <!-- Office Documents (DOCX, XLSX, PPTX) -->
            <div v-else-if="preview_type === 'office'" class="ratio ratio-16x9">
              <iframe :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
                width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
            </div>

            <!-- Text Files (TXT, CSV) -->
            <div v-else-if="preview_type === 'text'">
              <iframe :src="preview_url" width="100%" height="500px" frameborder="0" @load="on_content_loaded"></iframe>
            </div>

            <!-- Other / Unsupported Files -->
            <div v-else @load="on_content_loaded">
              <p>
                Preview not available. You can
                <a :href="preview_url" target="_blank" download>download the file</a>
                to view it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>